import { Card } from '@/components/ui/card';
import { apps } from '@/lib/apps';

/**
 * Pantalla de inicio del portal: lista las aplicaciones internas como
 * tarjetas, cada una enlazando a su Static Web App correspondiente.
 */
export function PortalPantalla() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Portal Adelante</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Seleccioná una aplicación para ingresar.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {apps.map((app) => {
          const Icono = app.icono;
          return (
            <a
              key={app.id}
              href={app.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-xl outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              <Card className="h-full p-6 transition-colors group-hover:border-primary">
                <div className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                    <Icono className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <div className="space-y-1">
                    <h2 className="font-semibold leading-none tracking-tight">{app.nombre}</h2>
                    <p className="text-sm text-muted-foreground">{app.descripcion}</p>
                  </div>
                </div>
              </Card>
            </a>
          );
        })}
      </div>
    </div>
  );
}
